/* @flow */

import * as React from 'react';
import uniqueId from 'lodash/uniqueId';
import {CopyButton} from '../button';
import {Label} from '../form';

import './copyable-link.css';

type Props = {
    label?: string,
    name: string,
    value: string,
    size: 'big' | 'xlarge',
    onCopy?: () => void,
};

export function CopyableLink(props: Props) {
    const copyableLinkRef = React.useRef(null);
    const idRef = React.useRef<string>(uniqueId('input_'));

    return (
        <React.Fragment>
            {props.label ? <Label htmlFor={idRef.current}>{props.label}</Label> : undefined}
            <div styleName='copyable-link'>
                <input
                    id={idRef.current}
                    name={props.name}
                    type='text'
                    ref={copyableLinkRef}
                    value={props.value}
                    onChange={() => {}}
                />
                <CopyButton
                    variant='primary'
                    size={props.size}
                    target={copyableLinkRef}
                    onCopy={props.onCopy}
                />
            </div>
        </React.Fragment>
    );
}
